import { withIcon } from "../Icon"

export const IconComment = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 19a7 7 0 1 0-6.222-3.79L5 19l3.79-.778A6.96 6.96 0 0 0 12 19Z"/>',
)
